import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Grid, Typography } from "@mui/material";
import { Editor } from 'primereact/editor';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import showToast from "../../../components/Hot-Toast/showToast";
import { jobResponsibilitySchema } from "../../../hooks/validationSchema";
import { customStep, nextStep, update } from "../../../slice/jobSlice";
import { useTMutation } from "../../../utils/useTMutation";

const JobResponsibility = () => {
    const dispatch = useDispatch();
    const { mutateAsync } = useTMutation("/job/addUpdateJob", "post", (data => { return data }));
    const { jobData, step } = useSelector(state => state.job)
    const { handleSubmit, formState: { errors }, watch, setValue } = useForm({
        resolver: zodResolver(jobResponsibilitySchema),
        defaultValues: {
            JOB_RESPONSIBILITY: jobData?.JOB_RESPONSIBILITY || "",
        }
    });
    const onSubmitNext = async (data) => {
        if (jobData.ID) data.ID = jobData.ID;
        try {
            const response = await mutateAsync({ ...data, ID: jobData?.ID, STEP: jobData.REDIRECT ? 8 : step + 1 });
            if (response.STATUS) {
                if (jobData.REDIRECT) {
                    dispatch(customStep(8))
                } else {
                    dispatch(nextStep())
                }
                dispatch(update({ ...data, "REDIRECT": false }))
            } else {
                showToast("error", data.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Validation Request failed:", error.message);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    return (
        <>
            <Grid container alignItems="center" spacing={1} justifyContent="space-around" px={1} pb={3}>
                <Grid item xs={12} sm={12} >
                    <Typography px={7} variant="h3" className="about-texts">
                        {/* Job Responsibility */}
                        {/* What are your job responsibilities? */}
                        Describe the job responsibilities
                    </Typography>
                </Grid>

                <form onSubmit={handleSubmit(onSubmitNext)}>
                    <Grid item mt={1}>
                        <Editor
                            value={watch("JOB_RESPONSIBILITY")}
                            onTextChange={(e) => setValue("JOB_RESPONSIBILITY", e.htmlValue?.toString())}
                            style={{ height: '320px', width: "750px" }}
                        />
                        {errors.JOB_RESPONSIBILITY && (
                            <Typography color="error" variant="body2" mt={1}>
                                {errors.JOB_RESPONSIBILITY.message}
                            </Typography>
                        )}
                    </Grid>

                    <Grid item xs={12} mt={2} sm={6} md={12} lg={12} style={{ justifyContent: "end", display: "flex" }}>
                        <Button
                            variant="contained"
                            // sx={{
                            //     backgroundColor: 'linear-gradient(to right,#4eb3e8,#6ebe44)',
                            //     color: 'white',
                            //     '&:hover': {
                            //         backgroundColor: '#5ca736',
                            //     },
                            // }}
                            className="custombuttons"
                            type="submit"
                        >
                            Add Job Duties
                        </Button>
                    </Grid>
                </form>
            </Grid>
        </>
    );
};

export default JobResponsibility;
